module.exports = __webpack_public_path__ + "img/horizontal_4_5_7016.8c853327.png";